module.exports = __webpack_public_path__ + "static/media/ic_play.3ea9d486.svg";